import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Tabs,
  Button,
  Form,
  Card,
  Typography,
} from "antd";
import Main from "../../components/layout/Main";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import TrophiesImage from "../../assets/images/trofies-image.svg";
import CalanderchackGreen from "../../assets/images/calander-check-green.svg";
import CalanderchackRed from "../../assets/images/calander-check-red.svg";
import CalanderchackWhite from "../../assets/images/calendar-check-white.svg";
import TeamredBg from "../../assets/images/team-red-background.svg";
import Teamredbanner from "../../assets/images/team-red-banner.svg";
import TeamredLogoFox from "../../assets/images/fox-logo.svg";
import LiningImage from "../../assets/images/line & dot.svg";
import TeamredLogoBull from "../../assets/images/bull-logo.svg";
import WinnerCrownIcon from "../../assets/images/winner-crown-icon.svg";
const { TabPane } = Tabs;
const { Text } = Typography;



const BracketsProgress = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selected, setSelected] = useState("gold");
  const [activeTab, setActiveTab] = useState("rules");


  return (
    <Main>
      <Breadcrumb
        className="for-route-path-head"
        separator={<img src={BreadcrumbArrow} alt=">" />}
      >
        <Breadcrumb.Item
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          Tournament
        </Breadcrumb.Item>
        <Breadcrumb.Item>Games</Breadcrumb.Item>
        <Breadcrumb.Item>Call of Duty</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <div className="games-versoin-name-header">
          <h4>Tournament Details</h4>
        </div>
        <div className="tournament-details-card">
          <div className="tournament-details-card-header">
            <h4>Call of Duty 2025</h4>
            <h6>27 March 2025</h6>
          </div>
          <div className="player-number">20 Players</div>
          <div className="player-trophies">
            <img src={TrophiesImage} />
            <span>Gold, Silver, Bronze trophies</span>
          </div>
          <div className="share-join-button">
            <Button className="light-button">Share</Button>
            <Button className="Fill-button">Join</Button>
          </div>
        </div>
        <div className="bracket-container">
          <Tabs defaultActiveKey="1" className="custom-tabs">
            <TabPane tab="Bracket" key="1">
              <div className="bracket-round-div-main">
                <div className="bracket-round-div bracket-round-div-green">
                  <h4>Round 1</h4>
                  <div className="bracket-round-div-image">
                    <img src={CalanderchackGreen} />
                  </div>
                </div>
                <div className="bracket-round-div bracket-round-div-green">
                  <h4>Round 2</h4>
                  <div className="bracket-round-div-image">
                    <img src={CalanderchackGreen} />
                  </div>
                </div>
                <div className="bracket-round-div bracket-round-div-red">
                  <h4>Semi-Final</h4>
                  <div className="bracket-round-div-image">
                    <img src={CalanderchackRed} />
                  </div>
                </div>
                <div className="bracket-round-div bracket-round-div-fill">
                  <h4>FINAL</h4>
                  <div className="bracket-round-div-image">
                    <img src={CalanderchackWhite} />
                  </div>
                </div>
              </div>

              <div className="final-main-div-new">
                <div className="semifinal-main-sections-kl">
                  <div className="team-card-main-all-semifinal">
                    <div className="team-card-main-all-inner">
                      <div className="team-card-main-all">
                        <div className="team-card-main">
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team A
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team B
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team C
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team D
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                        </div>
                        <div className="tram-cards">
                          <div className="team-red-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoFox}
                            />
                            <img
                              className="team-banner-crown-icob"
                              src={WinnerCrownIcon}
                            />
                            <div className="team-banner-team-name">Team A</div>
                            <div className="team-points-divv-green">3</div>
                          </div>
                          <div className="winner-time">
                            <img
                              className="team-banner-lining"
                              src={LiningImage}
                            />
                            03:30 PM, WINNER
                          </div>
                          <div className="team-green-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoBull}
                            />
                            <div className="team-banner-team-name">Team C</div>
                            <div className="team-points-divv-black">3</div>
                          </div>
                        </div>
                      </div>
                      <div className="team-card-main-all">
                        <div className="team-card-main">
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team E
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team F
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team G
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team H
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                        </div>
                        <div className="tram-cards">
                          <div className="team-red-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoFox}
                            />
                            <img
                              className="team-banner-crown-icob"
                              src={WinnerCrownIcon}
                            />
                            <div className="team-banner-team-name">Team E</div>
                            <div className="team-points-divv-green">3</div>
                          </div>
                          <div className="winner-time">
                            <img
                              className="team-banner-lining"
                              src={LiningImage}
                            />
                            03:30 PM, WINNER
                          </div>
                          <div className="team-green-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoBull}
                            />
                            <div className="team-banner-team-name">Team G</div>
                            <div className="team-points-divv-black">3</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tram-cards">
                      <div className="team-red-card">
                        <img className="team-banner-main" src={Teamredbanner} />
                        <img
                          className="team-banner-background"
                          src={TeamredBg}
                        />
                        <img
                          className="team-banner-logo"
                          src={TeamredLogoFox}
                        />
                        <img
                          className="team-banner-crown-icob"
                          src={WinnerCrownIcon}
                        />
                        <div className="team-banner-team-name">Team A</div>
                        <div className="team-points-divv-green">3</div>
                      </div>
                      <div className="winner-time">
                        <img className="team-banner-lining" src={LiningImage} />
                        03:30 PM, WINNER
                      </div>
                      <div className="team-green-card">
                        <img className="team-banner-main" src={Teamredbanner} />
                        <img
                          className="team-banner-background"
                          src={TeamredBg}
                        />
                        <img
                          className="team-banner-logo"
                          src={TeamredLogoBull}
                        />
                        <div className="team-banner-team-name">Team E</div>
                        <div className="team-points-divv-black">3</div>
                      </div>
                    </div>
                  </div>
                  <div className="team-card-main-all-semifinal">
                    <div className="team-card-main-all-inner">
                      <div className="team-card-main-all">
                        <div className="team-card-main">
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team I
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team J
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team K
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team L
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                        </div>
                        <div className="tram-cards">
                          <div className="team-red-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoFox}
                            />
                            <img
                              className="team-banner-crown-icob"
                              src={WinnerCrownIcon}
                            />
                            <div className="team-banner-team-name">Team I</div>
                            <div className="team-points-divv-green">3</div>
                          </div>
                          <div className="winner-time">
                            <img
                              className="team-banner-lining"
                              src={LiningImage}
                            />
                            03:30 PM, WINNER
                          </div>
                          <div className="team-green-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoBull}
                            />
                            <div className="team-banner-team-name">Team K</div>
                            <div className="team-points-divv-black">3</div>
                          </div>
                        </div>
                      </div>
                      <div className="team-card-main-all">
                        <div className="team-card-main">
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team M
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team N
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                          <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team O
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team P
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
                        </div>
                        <div className="tram-cards">
                          <div className="team-red-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoFox}
                            />
                            <img
                              className="team-banner-crown-icob"
                              src={WinnerCrownIcon}
                            />
                            <div className="team-banner-team-name">Team M</div>
                            <div className="team-points-divv-green">3</div>
                          </div>
                          <div className="winner-time">
                            <img
                              className="team-banner-lining"
                              src={LiningImage}
                            />
                            03:30 PM, WINNER
                          </div>
                          <div className="team-green-card">
                            <img
                              className="team-banner-main"
                              src={Teamredbanner}
                            />
                            <img
                              className="team-banner-background"
                              src={TeamredBg}
                            />
                            <img
                              className="team-banner-logo"
                              src={TeamredLogoBull}
                            />
                            <div className="team-banner-team-name">Team O</div>
                            <div className="team-points-divv-black">3</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tram-cards">
                      <div className="team-red-card">
                        <img className="team-banner-main" src={Teamredbanner} />
                        <img
                          className="team-banner-background"
                          src={TeamredBg}
                        />
                        <img
                          className="team-banner-logo"
                          src={TeamredLogoFox}
                        />
                        <img
                          className="team-banner-crown-icob"
                          src={WinnerCrownIcon}
                        />
                        <div className="team-banner-team-name">Team I</div>
                        <div className="team-points-divv-green">3</div>
                      </div>
                      <div className="winner-time">
                        <img className="team-banner-lining" src={LiningImage} />
                        03:30 PM, WINNER
                      </div>
                      <div className="team-green-card">
                        <img className="team-banner-main" src={Teamredbanner} />
                        <img
                          className="team-banner-background"
                          src={TeamredBg}
                        />
                        <img
                          className="team-banner-logo"
                          src={TeamredLogoBull}
                        />
                        <div className="team-banner-team-name">Team M</div>
                        <div className="team-points-divv-black">3</div>
                      </div>
                    </div>
                  </div>
                </div>
                 <div className="tram-cards">
                            <div className="team-red-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoFox}
                              />
                              <img
                                className="team-banner-crown-icob"
                                src={WinnerCrownIcon}
                              />
                              <div className="team-banner-team-name">
                                Team A
                              </div>
                              <div className="team-points-divv-green">3</div>
                            </div>
                            <div className="winner-time">
                              <img
                                className="team-banner-lining"
                                src={LiningImage}
                              />
                              03:30 PM, WINNER
                            </div>
                            <div className="team-green-card">
                              <img
                                className="team-banner-main"
                                src={Teamredbanner}
                              />
                              <img
                                className="team-banner-background"
                                src={TeamredBg}
                              />
                              <img
                                className="team-banner-logo"
                                src={TeamredLogoBull}
                              />
                              <div className="team-banner-team-name">
                                Team B
                              </div>
                              <div className="team-points-divv-black">3</div>
                            </div>
                          </div>
              </div>
            </TabPane>
            <TabPane tab="Progress" key="2">
              {/* Progress UI goes here */}
              <div className="progress">Progress content here</div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </Main>
  );
};

export default BracketsProgress;
